import API_BASE_URL from './config';
import React from 'react';
import { Link } from 'react-router-dom';

function AdminArea() {
  const adminId = localStorage.getItem('playerId');

  if (!adminId) return <p style={{ textAlign: 'center', color: '#333' }}>Please log in as an admin.</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', color: '#333', marginBottom: '20px' }}>Admin Area</h1>
      <h2 style={{ color: '#4CAF50', textAlign: 'center', marginBottom: '15px' }}>Admin Tools</h2>
      <ul style={{ 
        listStyle: 'none', 
        padding: 0, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center' 
      }}>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/dogs" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Dog Registration Approvals
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/update-requests" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Dog Update Requests
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/kennels" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Kennel Registration Approvals
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/kennel-images" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Kennel Image Update Approvals
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/staff-approval" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Staff Registration Approvals
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/skills" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Staff Skill Submission Approvals
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/titles" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Title Approvals
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/verify-ap" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Award Points Verification
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin-rolling" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            iCON RNG Roller
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/admin/training" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Training Submission Approvals
          </Link>
        </li>
        <li style={{ marginBottom: '10px' }}>
          <Link to="/merit-confo/admin" style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            iCON Merit-Confo Admin Dashboard
          </Link>
        </li>
                <li style={{ marginBottom: '10px' }}>
          <Link to="/judge-closed-icon-merit"  style={{ color: '#0000FF', textDecoration: 'none', fontSize: '18px' }} onMouseOver={e => e.target.style.color = '#4CAF50'} onMouseOut={e => e.target.style.color = '#0000FF'}>
            Judge iCON Merit Shows
          </Link>
          </li>
      </ul>
    </div>
  );
}

export default AdminArea;